import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './pages/Home';
import Veil from './pages/Veil';
import Devotion from './pages/Devotion';
import Prayer from './pages/Prayer';
import Chaplet from './pages/Chaplet';
import './styles/App.css';

function App() {
    return (
        <div className="app">
            <Nav />
            <Routes>
                <Route path="/"         element={<Home />} />
                <Route path="/veil"     element={<Veil />} />
                <Route path="/devotion" element={<Devotion />} />
                <Route path="/prayer"   element={<Prayer />} />
                <Route path="/chaplet"  element={<Chaplet />} />
            </Routes>
        </div>
    );
}

export default App;
